var SpriteSymbol = require("../../node_modules/svg-baker-runtime/browser-symbol.js");
var sprite = require("../../node_modules/svg-sprite-loader/runtime/browser-sprite.build.js");
var symbol = new SpriteSymbol({
  "id": "mail",
  "use": "mail-usage",
  "viewBox": "0 0 24 24",
  "content": "<symbol viewBox=\"0 0 24 24\" xmlns=\"http://www.w3.org/2000/svg\" id=\"mail\">\n    <path fill-rule=\"evenodd\" clip-rule=\"evenodd\" d=\"M3 4H21C22.1046 4 23 4.79594 23 5.77778V18.2222C23 19.2041 22.1046 20 21 20H3C1.89543 20 1 19.2041 1 18.2222V5.77778C1 4.79594 1.89543 4 3 4ZM3 8.6181V18H21V8.61851L12 13.1185L3 8.6181ZM3 6.38199L12 10.8824L21 6.38245V6H3V6.38199Z\" />\n</symbol>"
});
var result = sprite.add(symbol);
module.exports = symbol